import React from "react";
import { PageHeaderContainer } from "./styles";

const PageHeader = ({ children, ...rest }: any) => (
    <PageHeaderContainer {...rest}>{children}</PageHeaderContainer>
);

export default PageHeader;
